<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-5">Sistemos parametrai</h3>

    <v-row class="mb-2">
      <v-col cols="12">
        <v-tabs v-model="grupe">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            class="parametrai-tab"
            v-for="item in grupes"
            :key="`parametraigrupe${item.value}`"
          >
            <h4>{{ item.text }}</h4>
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :page.sync="page"
      :items-per-page="pageSize"
    >
      <template #top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template #[`item.par_reiksme`]="{ item }">
        <template v-if="item.isAutocomplete">
          <el-autocomplete
            class="mt-0 mb-2"
            :items="darboDienosList"
            itemvalue="value"
            itemtext="text"
            label=" "
            hide-details="auto"
            :readonly="item.isReadonly"
            v-model="item.par_reiksme"
          />
        </template>
        <template v-if="item.isSwitch">
          <el-switch
            v-model="item.par_reiksme"
            true-value="1"
            false-value="0"
            :readonly="item.isReadonly"
            :label="`${item.par_reiksme === '1' ? 'įjungtas' : 'išjungtas'}`"
          />
        </template>
        <template v-if="item.isText">
          <el-text-field
            :key="item.par_kodas"
            :validate-key="item.par_kodas"
            class="mb-2 mt-0"
            label=" "
            hide-details="auto"
            :email="item.par_kodas === 'kac_email'"
            :readonly="item.isReadonly"
            v-model="item.par_reiksme"
          />
        </template>
      </template>
      <template #[`item.par_pavadinimas`]="{ item }">
        <div :class="item.pavadinimasClass">
          {{ item.par_pavadinimas
          }}<template
            v-if="
              item.par_kodas === 'rinkmena_dydis' ||
                item.par_kodas === 'rinkmena_dydis_nep'
            "
            >, didžiausia reikšmė {{ rinkmenaDydisServeris }} MB
          </template>
        </div>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <v-footer class="form-footer">
      <el-button primary @click.native="saveData()" :loading="loading"
        >Saugoti</el-button
      >
      <el-button @click.native="cancelData()" :loading="loading"
        >Atšaukti</el-button
      >
      <v-spacer></v-spacer>
    </v-footer>
  </v-container>
</template>

<script>
import unsavedData from '../../mixins/unsavedData'
import print from '../../mixins/print'

export default {
  name: 'AdminParametrai',
  mixins: [unsavedData, print],
  data() {
    return {
      pageloading: true,
      loading: true,
      formData: [],
      rinkmenaDydisServeris: null,
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 50,
      page: 1,
      grupe: 0,
      darboDienos: [],
    }
  },
  computed: {
    grupes() {
      return [
        {
          text: 'TURTAS sistemos parametrai',
          value: 'turtas',
          ntrpaslaugos: 0,
        },
        {
          text: 'NEP sistemos parametrai',
          value: 'ntrpaslaugos',
          ntrpaslaugos: 1,
        },
      ]
    },
    grupeValue() {
      return this.grupes[this.grupe].value
    },
    grupeNtrPaslaugos() {
      return this.grupes[this.grupe].ntrpaslaugos
    },
    headers() {
      return [
        {
          text: 'Pavadinimas',
          align: 'start',
          sortable: true,
          value: 'par_pavadinimas',
        },
        {
          text: 'Reikšmė',
          align: 'start',
          sortable: true,
          value: 'par_reiksme',
        },
        {
          text: 'Pakeitimo data',
          align: 'start',
          sortable: true,
          value: 'par_atnaujinimo_data',
        },
        {
          text: 'Pakeitimą atlikęs asmuo',
          align: 'start',
          sortable: true,
          value: 'busena_pakeite',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.formData.map((item, index) => {
        item.isAutocomplete = item.darbo_dienos
        item.isSwitch = item.boolean
        item.isText = !item.isAutocomplete && !item.isSwitch
        item.isReadonly = this.readonlyItems.includes(item.par_kodas)
        item.pavadinimasClass = item.isReadonly ? 'text-gray' : ''
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 50
    },
    isSearch() {
      return this.search != null && this.search.length > 0
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
    isTest() {
      return process.env.VUE_APP_LOCAL === 'test'
    },
    darboDienosList() {
      return Object.entries(this.darboDienos).map(([key, item]) => {
        return {
          value: key,
          text: item,
        }
      })
    },
    readonlyItems() {
      if (this.isLocal || this.isDevelop || this.isTest) {
        return []
      }
      return ['termino_laikas_ntr', 'termino_laikas_nep']
    },
  },
  watch: {
    grupe() {
      this.getData()
    },
  },
  created() {
    this.getKlasif()
    this.getData()
  },
  methods: {
    getKlasif() {
      const data = {
        klasifikatoriai: ['admin_darbo_dienos'],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.darboDienos = res.data.list.admin_darbo_dienos
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {})
    },
    getData() {
      this.pageloading = true
      this.loading = true

      const data = {
        params: { ntrpaslaugos: this.grupeNtrPaslaugos },
      }

      this.$axios
        .get(`admin/parametras`, data)
        .then(res => {
          this.formData = res.data.parametrai
          this.rinkmenaDydisServeris = res.data.rinkmena_dydis_serveris
          this.initialForm()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData(toRoute) {
      this.loading = true

      let data = {
        parametrai: this.formData,
      }

      this.$axios
        .post(`admin/parametras`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          if (toRoute) {
            this.goToRoute()
          } else {
            this.getData()
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelData() {
      this.getData()
    },
  },
}
</script>
